import { useSortable } from "@dnd-kit/sortable";
import { CSSProperties, FC } from "react";

import { IDashboardCard } from "../dynamic-dashboard.models";
import { DynamicDashboardCard } from "./dynamic-dashboard-card";

/**
 * dnd-kit `useSortable` wrapper around the presentational card. The 6-dot grip
 * (inside the card header) is the drag activator via `listeners`.
 *
 * We deliberately do NOT apply the sortable `transform`: shifting mixed-size
 * cards (wide vs narrow) around with `rectSortingStrategy` assumes uniform grid
 * cells, which makes cards jump and overlap ("afterimage"). Instead the source
 * is hidden (its slot preserved) while the floating overlay is the preview, the
 * hovered card is highlighted (`isOver`), and the reorder is applied on drop.
 */
export const DynamicDashboardSortableCard: FC<{
  card: IDashboardCard;
  shouldAnimateAppear?: boolean;
}> = ({ card, shouldAnimateAppear }) => {
  const { attributes, listeners, setNodeRef, isDragging, isOver } = useSortable(
    { id: card.id },
  );

  const style: CSSProperties = {
    visibility: isDragging ? "hidden" : undefined,
  };

  return (
    <DynamicDashboardCard
      card={card}
      shouldAnimateAppear={shouldAnimateAppear}
      setNodeRef={setNodeRef}
      style={style}
      attributes={attributes}
      listeners={listeners}
      isDragging={isDragging}
      isOver={isOver}
    />
  );
};
